module.exports = __webpack_public_path__ + "static/media/Sakshi-Mehta.6efa174b.png";